import React from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

function SearchBar({ searchTerm, setSearchTerm, filteredCount, totalCount }) {
  return (
    <Box sx={{ mb: 3, mt: -4}}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          {searchTerm ? `${filteredCount} of ${totalCount} documents` : `${totalCount} documents`}
        </Typography>
      </Box>
      <TextField
        size="small"
        fullWidth
        placeholder="Search Knowledge Base..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        InputProps={{
          startAdornment: <SearchIcon sx={{ color: 'text.secondary', mr: 1 }} />,
        }}
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: '#ffffff',
            borderRadius: 2,
          }
        }}
      />
    </Box>
  );
}

export default SearchBar;
